import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.REOPEN_ACCOUNT)
export default class ReopenAccount extends BaseModel {
  @StringField()
  public loginOrEmail: string

  @StringField()
  public fullName: string
}
